import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MaterialModule } from 'src/app/core/material.module';
import { PatientsService } from 'src/app/features/patients/services/patients.service';



@Component({
  selector: 'app-patient-add-comment',
  templateUrl: './patient-add-comment.component.html',
  styleUrls: ['./patient-add-comment.component.scss'],
   imports: [CommonModule, MaterialModule, ReactiveFormsModule,]
})
export class PatientAddCommentComponent implements OnInit,OnChanges {
@Output() commentFormValue = new EventEmitter();

@Input() patientData:any;
  constructor( public patientService: PatientsService) {
    this.patientService.eventEmitter.subscribe((d) => {
      if(d == 'app-patient-add-comment') {
        this.sendData();
      }
      if(d == 'reset') {
        this.patientDetailAddComment.reset();
      }
    });
  }

  ngOnInit(): void {
  }
  ngOnChanges(){
    this.setFormValue();
  }
  public patientDetailAddComment = new FormGroup({

    comments: new FormControl('', [
      Validators.minLength(1),
      Validators.maxLength(256)
    ])
  });

  sendData(){
    this.commentFormValue.emit({valid: true, form: 'app-patient-add-comment', value: this.patientDetailAddComment.value});
  }

  setFormValue(){
    console.log('helo from comment update data', this.patientData);
    this.patientDetailAddComment.patchValue({
      comments: this?.patientData?.comments || ''
    })
  }
}
